module.exports = "/_next/static/images/truck9-685c6e00065bd9347aa1dd2383842ae1.png.webp";